<div class="container">
  <div *ngIf="trendingFr.length">
    <div class="trending-setion" [ngClass]="{'trending-section-1': vwo.homepage_banner_AB()}">
      <h2>Trending Fundraisers</h2>
      <p class="subtext">View the fundraisers that are most active right now</p>
      <div class="card-wrapper widget-height">
        <ngx-glide [showArrows]="true" [showBullets]="false" [breakpoints]="breakpoints" [perView]="3" [bound]="true" [gap]="0" arrowLeftLabel="" arrowRightLabel="">
          <app-widget *ngFor="let fr of trendingFr" [widgetData]="fr" [currency]="currency" [showShareBtn]="true"></app-widget>
        </ngx-glide>
      </div>
      <a [routerLink]="['/new/browse']" class="float-right view-more">View More<i class="material-icons">arrow_forward</i></a>
      <!-- <hr class="separator d-lg-none d-md-none"/> -->
    </div>
  </div>
</div>
